"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.previousOtherOrganTransplantationTypeMessages = exports.hasPreviousOtherOrganTransplantationMessages = exports.PreviousOtherOrganTransplantationType = exports.HasPreviousOtherOrganTransplantation = void 0;
const schema_1 = require("../../../../../schema");
var HasPreviousOtherOrganTransplantation;
(function (HasPreviousOtherOrganTransplantation) {
    HasPreviousOtherOrganTransplantation["HAS_PREVIOUS_OTHER_ORGAN_TRANSPLANTATION"] = "has_previous_other_organ_transplantation";
    HasPreviousOtherOrganTransplantation["NO_UNKNOWN_PREVIOUS_OTHER_ORGAN_TRANSPLANTATION"] = "no_unknown_previous_other_organ_transplantation";
})(HasPreviousOtherOrganTransplantation || (exports.HasPreviousOtherOrganTransplantation = HasPreviousOtherOrganTransplantation = {}));
var PreviousOtherOrganTransplantationType;
(function (PreviousOtherOrganTransplantationType) {
    PreviousOtherOrganTransplantationType["PREVIOUS_TRANSPLANTATION_KIDNEY"] = "previous_transplantation_kidney";
    PreviousOtherOrganTransplantationType["PREVIOUS_TRANSPLANTATION_LIVER"] = "previous_transplantation_liver";
    PreviousOtherOrganTransplantationType["PREVIOUS_TRANSPLANTATION_HEART"] = "previous_transplantation_heart";
    PreviousOtherOrganTransplantationType["PREVIOUS_TRANSPLANTATION_LUNG"] = "previous_transplantation_lung";
    PreviousOtherOrganTransplantationType["PREVIOUS_TRANSPLANTATION_PANCREAS"] = "previous_transplantation_pancreas";
    PreviousOtherOrganTransplantationType["PREVIOUS_TRANSPLANTATION_BONE_MARROW"] = "previous_transplantation_bone_marrow";
    PreviousOtherOrganTransplantationType["PREVIOUS_TRANSPLANTATION_OTHER"] = "previous_transplantation_other";
})(PreviousOtherOrganTransplantationType || (exports.PreviousOtherOrganTransplantationType = PreviousOtherOrganTransplantationType = {}));
exports.hasPreviousOtherOrganTransplantationMessages = {
    [HasPreviousOtherOrganTransplantation.HAS_PREVIOUS_OTHER_ORGAN_TRANSPLANTATION]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.hasPreviousOtherOrganTransplantation.HAS_PREVIOUS_OTHER_ORGAN_TRANSPLANTATION",
        defaultMessage: "Történt korábbi transzplantáció"
    },
    [HasPreviousOtherOrganTransplantation.NO_UNKNOWN_PREVIOUS_OTHER_ORGAN_TRANSPLANTATION]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.hasPreviousOtherOrganTransplantation.NO_UNKNOWN_PREVIOUS_OTHER_ORGAN_TRANSPLANTATION",
        defaultMessage: "Nem történt korábbi transzplantáció"
    }
};
exports.previousOtherOrganTransplantationTypeMessages = {
    [PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_KIDNEY]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.previousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_KIDNEY",
        defaultMessage: "Vese transzplantáció"
    },
    [PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LIVER]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.previousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LIVER",
        defaultMessage: "Máj transzplantáció"
    },
    [PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_HEART]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.previousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_HEART",
        defaultMessage: "Szív transzplantáció"
    },
    [PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LUNG]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.previousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LUNG",
        defaultMessage: "Tüdő transzplantáció"
    },
    [PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_PANCREAS]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.previousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_PANCREAS",
        defaultMessage: "Pancreas transzplantáció"
    },
    [PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_BONE_MARROW]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.previousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_BONE_MARROW",
        defaultMessage: "Csontvelő transzplantáció"
    },
    [PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_OTHER]: {
        id: "ktx.basicRegistrationData.clinicalData.preImmunisation.previousOtherOrganTransplantation.previousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_OTHER",
        defaultMessage: "Egyéb szerv vagy szövet transzplantáció"
    }
};
const hasPreviousOtherOrganTransplantation = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HasPreviousOtherOrganTransplantation.HAS_PREVIOUS_OTHER_ORGAN_TRANSPLANTATION).interpretation({
        vocab: "ktx",
        code: "has_previous_other_organ_transplantation"
    }),
    schema_1.Schema.singleChoiceItem(HasPreviousOtherOrganTransplantation.NO_UNKNOWN_PREVIOUS_OTHER_ORGAN_TRANSPLANTATION)
        .interpretation({
        vocab: "ktx",
        code: "no_unknown_previous_other_organ_transplantation"
    })
        .tag({ vocab: "ktx", code: "previous_other_organ_transplantation" })
]).interpretation({
    vocab: "ktx",
    code: "has_previous_other_organ_transplantation_choice"
});
const previousOtherOrganTransplantationType = schema_1.Schema.multiChoice([
    schema_1.Schema.multiChoiceItem(PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_KIDNEY)
        .interpretation({
        vocab: "ktx",
        code: "previous_transplantation_kidney"
    })
        .tag({ vocab: "ktx", code: "previous_other_organ_transplantation" }),
    schema_1.Schema.multiChoiceItem(PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LIVER)
        .interpretation({
        vocab: "ktx",
        code: "previous_transplantation_liver"
    })
        .tag({ vocab: "ktx", code: "previous_other_organ_transplantation" }),
    schema_1.Schema.multiChoiceItem(PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_HEART)
        .interpretation({
        vocab: "ktx",
        code: "previous_transplantation_heart"
    })
        .tag({ vocab: "ktx", code: "previous_other_organ_transplantation" }),
    schema_1.Schema.multiChoiceItem(PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LUNG)
        .interpretation({ vocab: "ktx", code: "previous_transplantation_lung" })
        .tag({ vocab: "ktx", code: "previous_other_organ_transplantation" }),
    schema_1.Schema.multiChoiceItem(PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_PANCREAS)
        .interpretation({
        vocab: "ktx",
        code: "previous_transplantation_pancreas"
    })
        .tag({ vocab: "ktx", code: "previous_other_organ_transplantation" }),
    schema_1.Schema.multiChoiceItem(PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_BONE_MARROW)
        .interpretation({
        vocab: "ktx",
        code: "previous_transplantation_bone_marrow"
    })
        .tag({ vocab: "ktx", code: "previous_other_organ_transplantation" }),
    schema_1.Schema.multiChoiceItem(PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_OTHER)
]);
const previousOtherOrganTransplantationTypeOther = schema_1.Schema.ifThen(schema_1.Schema.expression(`Array.isArray({../previousOtherOrganTransplantationType}) && ({../previousOtherOrganTransplantationType}).includes("previous_transplantation_other")`), schema_1.Schema.string()
    .maxLength(10000)
    .interpretation({
    vocab: "ktx",
    code: "previous_transplantation_other"
})
    .tag({ vocab: "ktx", code: "previous_other_organ_transplantation" }));
const previousOtherOrganTransplantations = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../hasPreviousOtherOrganTransplantation} === "has_previous_other_organ_transplantation"`), schema_1.Schema.object().default({}).sealed(true).properties({
    previousOtherOrganTransplantationType,
    previousOtherOrganTransplantationTypeOther
}));
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({
    hasPreviousOtherOrganTransplantation,
    previousOtherOrganTransplantations
})
    .interpretation({
    vocab: "ktx",
    code: "previous_other_organ_transplantation_statement"
});
